import { render } from "./DigitalServices.vue?vue&type=template&id=3331990c&scoped=true&ts=true"
import script from "./DigitalServices.vue?vue&type=script&lang=ts"
export * from "./DigitalServices.vue?vue&type=script&lang=ts"

import "./DigitalServices.vue?vue&type=style&index=0&id=3331990c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3331990c"]])

export default __exports__